<template>
 <main class="d-flex align-items-center min-vh-100 py-3 py-md-0">
      <div class="container">
        <div class="card login-card">
  <v-app>
    <div class="card-body" style="position:relative">
      <v-container>
        <v-row>
          <h1>Ceci est un test</h1>

          <GmapMap
            ref="mymap"
            :center="positionclient"
            :zoom="12"
            map-type-id="terrain"
            style="width: 100%; height: 400px; "
          >
            <GmapInfoWindow
              :options="infoOptions"
              :position="infoWindowPos"
              :opened="infoWinOpen"
              @closeclick="infoWinOpen = false"
            >
              <h1>this is a test</h1>
            </GmapInfoWindow>

            <GmapMarker
              v-for="(order, keyorder) in orders"
              :key="keyorder"
              :position="order.order.delivery.locationdetails.location"
              :clickable="true"
              :draggable="true"
              @click.prevent="toggleInfoWindow(m, i)"
              @dragend="updateCoordinates"
            />
          </GmapMap>
        </v-row>
      </v-container>
    </div>
  </v-app>
    </div>
      </div>
    </main>
</template>

<script>
import { gmapApi } from "vue2-google-maps";

export default {
  props: {},
  computed: {
    google: function() {
      return gmapApi;
    }
  },
  components: {},
  data() {
    return {
      datasreported: {},
      redirect: "https://sandbox.ojay.delivery",
      deliveryman_id: "Grandneuydegeur034D432efdf",
      shopid: "IDvxsf34554cddfgFGgtf444534v89898",
      orders: [],
      positionclient: {
        lat: 14.7167,
        lng: -17.4677
      },
      infoOptions: {
        content: "",
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      infoWindowPos: null,
      infoWinOpen: false
    };
  },
  watch: {},
  mounted() {
    this.getAllDelivery();
  },
  methods: {
    toggleInfoWindow: function(marker, idx) {
      console.log('toggleInfoWindow ==>',marker,idx)
      this.infoWindowPos = marker.position;
      this.infoOptions.content = marker.infoText;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    updateCoordinates(location) {
      //console.log('updateCoordinates',location.latLng)
      this.positionclient = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng()
      };
      this.datasreported.current_position = this.positionclient;
    },
    getAllDelivery() {
      const pathorder =
        this.redirect + "/ojaybackend/get/orders/" + this.shopid;

      this.$http.get(pathorder).then(
        function(response) {
          console.log("response data done zer", response.data.orders);
          this.orders = response.data.orders;
        },
        function(error) {
          console.log("---------------------------");

          console.log(error);
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/DeliveryMan.vue